import './ArchibusService.css';
import Footer from '../../components/footer/Footer';
import ModuleColumn from "./AbModuleColumn";
import hexes from '../../assets/img/hexes';
import Translator from "../../translates/Translator";
import usePageMeta from '../../hooks/usePageMeta';
import {
    Row,
    Col
} from 'react-bootstrap';

const ArchibusService = () => {
    const t = Translator();
    usePageMeta(`${t("archibus")} | IKA DATA`, t("archibus-title2-desc"));
    const modulesData = [
        {
            title: t("module1"),
            iconClass: "fa-hand-holding-dollar",
            items: [t("module1-page1"), t("module1-page2"), t("module1-page3")]
        },
        {
            title: t("module2"),
            iconClass: "fa-screwdriver-wrench",
            items: [t("module2-page1"), t("module2-page2"), t("module2-page3")]
        },
        {
            title: t("module5"),
            iconClass: "fa-headset",
            items: [
                t("module5-page1"),
                t("module5-page2"),
                t("module5-page3"),
                t("module5-page4")
            ]
        },
        {
            title: t("module6"),
            iconClass: "fa-magnifying-glass-dollar",
            items: [t("module6-page1"), t("module6-page2"), t("module6-page3")]
        },
        {
            title: t("module3"),
            iconClass: "fa-map-location-dot",
            items: [
                t("module3-page1"),
                t("module3-page2"),
                t("module3-page3"),
                t("module3-page4"),
                t("module3-page5")
            ]
        },
        {
            title: t("module8"),
            iconClass: "fa-plug-circle-plus",
            items: [
                t("module8-page1"),
                t("module8-page2"),
                t("module8-page3"),
                t("module8-page4"),
                t("module8-page5")
            ]
        },
        {
            title: t("module7"),
            iconClass: "fa-seedling",
            items: [
                t("module7-page1"),
                t("module7-page2"),
                t("module7-page3"),
                t("module7-page4"),
                t("module7-page5"),
                t("module7-page6"),
                t("module7-page7"),
                t("module7-page8")
            ]
        },
        {
            title: t("module4"),
            iconClass: "fa-building-circle-check",
            items: [
                t("module4-page1"),
                t("module4-page2"),
                t("module4-page3"),
                t("module4-page4"),
                t("module4-page5"),
                t("module4-page6"),
                t("module4-page7")
            ]
        }
    ];

    return (
        <div className=''>
            <div className="header-filler"></div>
            <div className='archibus'>
                <h1 className="visually-hidden">{t("archibus-title1")}</h1>
                <Row className="m-0 mt-4 justify-content-center">
                    <Col xs={12} lg={4} xl={5} className="align-content-center">
                        <img src="/reference_logos/archibus_logo.png" alt="Archibus Logo" className="archibus-logo" />
                    </Col>
                    <Col xs={12} lg={8} xl={7} xxl={6} className="ps-lg-5">
                        <p className="mt-5 mt-sm-3 mt-lg-0">{t("archibus-desc1")}</p>
                        <p className="mb-0">{t("archibus-desc2")}</p>
                    </Col>
                </Row>

                <div className='ab-service-offer warm-light-bg p-3 p-sm-5 pt-0 br-4 shadow-8-2-inset'>
                    <h2 className='text-center mb-5'>{t("archibus-title2")}</h2>
                    <Row className='justify-content-center column-gap-xl-4'>
                        <Col xs={12} md={6} xl={6} className='align-content-center'>
                            <p>{t('archibus-title2-desc')}</p>
                        </Col>
                        <Col xs={12} md={6} xl={5} className='mt-4 mt-md-0'>
                            <ul className='ps-4 ab-services-list'>
                                <li>
                                    <div class="feature-icon">
                                        <i className={`fa-solid fa-laptop-code`}></i>
                                    </div>
                                    {t('archibus-service1')}
                                </li>
                                <li>
                                    <div class="feature-icon">
                                        <i className={`fa-solid fa-cloud `}></i>
                                    </div>
                                    {t('archibus-service2')}
                                </li>
                                <li>
                                    <div class="feature-icon">
                                        <i className={`fa-solid fa-network-wired `}></i>
                                    </div>
                                    {t('archibus-service3')}
                                </li>
                                <li>
                                    <div class="feature-icon">
                                        <i className={`fa-solid fa-headset `}></i>
                                    </div>
                                    {t('archibus-service4')}
                                </li>
                            </ul>
                        </Col>
                    </Row>
                </div>

                <h2 className="text-center modules-title">{t("archibus-title3")}</h2>
                <img src={hexes.h3_80} className="hex3 o-30" alt='' />
                <img src={hexes.h3_80} className="hex3 o-30" alt='' />
                <img src={hexes.h3_80} className="hex3 o-30" alt='' />
                <Row className='m-0 mt-3 mb-5 align-items-start ab-module-column justify-content-center'>
                    {modulesData.map((module, idx) => (
                        <ModuleColumn
                            key={idx}
                            title={module.title}
                            iconClass={module.iconClass}
                            items={module.items}
                        />
                    ))}
                </Row>
            </div >
            <Footer />
        </div >
    );
}

export default ArchibusService;